import xbbFunction from './xbb-function'

export const missionType = {
  bind: 1, // 綁定
  promote: 3, // 推廣
  view: 5, // 查看
  finish: 6, // 已完成
  guest: 7, // 訪客
  guestBind: 8 // 訪客綁定
}

export const xbbEventType = {
  windowClose: 'EVENT_THIRDPARTY_CLOSE',
  reload: 'EVENT_THIRDPARTY_RELOAD',
  login: 'EVENT_THIRDPARTY_LOGIN',
  bankcard: 'EVENT_THIRDPARTY_BANKCARD',
  home: 'EVENT_THIRDPARTY_HOME',
  joinMember: 'EVENT_THIRDPARTY_JOINMEMBER'
}

// 外接方使用 iframe 載入我們頁面，要离开页面时，我们需要送出 message
export function xbbAction (event) {
  // WEB
  try {
    parent.postMessage({ event: event }, '*')
  } catch (err) {
    console.error(`web: ${err}`)
  }

  // iOS, Android
  try {
    xbbFunction.jsToAppMessage(event)
  } catch (err) {
    console.error(`iOS and Android: ${err}`)
  }
}



// WEBPACK FOOTER //
// ./src/views/xbb/utils.js